module.exports = __webpack_public_path__ + "static/img/solutionDetailPic6.2c02808.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic6.jpg
// module id = 5ohZ
// module chunks = 1